import { LocationCard } from '@/components/Card'
import { EmptyList } from '@/components/EmptyList'
import { SidePanel } from '@/components/SidePanel'
import { useLocations } from '@/queries/locations/useLocations'
import { useRemoveLocationFromWorkspace } from '@/queries/locations/useRemoveLocationFromWorkspace'
import Grid from '@mui/material/Grid'
import { useStytchOrganization } from '@stytch/react/b2b'
import { Location } from 'honeygrid-types'
import { enqueueSnackbar } from 'notistack'
import { useNavigate, useSearchParams } from 'react-router-dom'

export const LocationsList = () => {
	const [searchParams] = useSearchParams()
	const { organization } = useStytchOrganization<false>()
	const navigate = useNavigate()
	const { data: locations, isLoading } = useLocations({
		workspaceId: organization?.organization_id,
	})
	const selectedLocationId = searchParams.get('locationId')
	const showEmptyList = !isLoading && !locations?.length
	const { mutateAsync: removeLocationFromWorkspace } = useRemoveLocationFromWorkspace()

	const handleRemoveLocation = async (locationId: Location['uuid']) => {
		try {
			await removeLocationFromWorkspace({
				workspaceId: organization?.organization_id,
				locationId,
			})
			enqueueSnackbar('Location removed successfully', { variant: 'success' })
		} catch (error) {
			console.error('Failed to remove location:', error)
			enqueueSnackbar('Failed to remove location', { variant: 'error' })
		}
	}

	return (
		<SidePanel
			header={{
				title: 'Locations',
				onAdd: () => {
					navigate('add')
				},
			}}
		>
			<Grid container maxWidth="100%" margin={0} alignItems="center" rowSpacing={2}>
				{showEmptyList ? (
					<Grid container alignItems="center" size={12}>
						<EmptyList
							componentPluralName="locations"
							componentSingularName="location"
							onAdd={() => {
								navigate('add')
							}}
						/>
					</Grid>
				) : (
					locations?.map((location) => (
						<Grid key={location.id} size={12}>
							<LocationCard
								location={location}
								isSelected={location.uuid === selectedLocationId}
								onRemove={() => handleRemoveLocation(location.uuid)}
							/>
						</Grid>
					))
				)}
			</Grid>
		</SidePanel>
	)
}
